"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _user = require("@/api/user");
var _breadCrumb = _interopRequireDefault(require("@/components/breadCrumb"));
var _hamBurger = _interopRequireDefault(require("@/components/hamBurger"));
var _screenFull = _interopRequireDefault(require("@/components/screenFull"));
var _headerNotice = _interopRequireDefault(require("@/components/headerNotice"));
var _headerSearch = _interopRequireDefault(require("@/components/headerSearch"));
var _settings = require("@/settings");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Breadcrumb: _breadCrumb.default,
    Hamburger: _hamBurger.default,
    Screenfull: _screenFull.default,
    HeaderNotice: _headerNotice.default,
    Search: _headerSearch.default
  },
  data: function data() {
    return {
      roterPre: _settings.roterPre,
      adminInfo: _jsCookie.default.set('MerName'),
      label: ''
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebar', 'avatar', 'device'])),
  mounted: function mounted() {
    var _this = this;
    (0, _user.getBaseInfo)().then(function (res) {
      console.log(res);
      _this.$store.dispatch('user/set_merchant_id', res.data.mer_id);
      _this.$store.dispatch('user/set_uname', res.data.real_name);
      _this.$store.dispatch('user/set_merchant_avtar', res.data.mer_avatar);
      _this.$store.dispatch('user/set_merchant_logo', res.data.mer_logo);
      _this.$store.dispatch('user/set_merchant_name', res.data.mer_name);
      _this.label = res.data;
    }).catch(function (_ref) {
      var message = _ref.message;
    });
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    goUser: function goUser() {
      this.$modalForm((0, _user.editFormApi)());
    },
    goPassword: function goPassword() {
      this.$modalForm((0, _user.passwordFormApi)());
    },
    logout: function () {
      var _logout = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              this.$router.push("".concat(_settings.roterPre, "/login?redirect=").concat(this.$route.fullPath));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};
exports.default = _default;